import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { Link } from "react-router-dom";

const BlogCard = ({ item, index }) => {
  const cardRef = useRef(null);
  const cardShadowAnimation = useRef(null);
  const iconAnimation = useRef(null);

  useEffect(() => {
    if (!cardRef.current) {
      console.error("Card ref is not set");
      return;
    }

    // Define the icon animation with fade in
    iconAnimation.current = gsap.fromTo(
      cardRef.current.querySelector(".iconsList"),
      { y: -100, opacity: 0 }, // Start position and opacity
      {
        y: 0,
        opacity: 1,
        delay: 0.5,
        ease: "power2.inOut", // Updated to GSAP 3 syntax
        duration: 0.5, // Duration for icon animation
      }
    );

    // Initialize the card shadow animation
    cardShadowAnimation.current = gsap.to(cardRef.current, {
      boxShadow: `0px 0px 10px ${item.activeColor}`, // Use the activeColor for the shadow
      border: `1px solid ${item.activeColor}`,
      paused: true, // Pause animation initially
      duration: 0.3, // Animation duration for shadow
      ease: "power2.inOut",
    });
  }, [item.activeColor]); // Effect runs when activeColor changes

  const onMouseEnterHandler = () => {
    if (cardShadowAnimation.current) {
      console.log("Playing animation");
      cardShadowAnimation.current.play(); // Play animation on hover
    }
  };

  const onMouseLeaveHandler = () => {
    if (cardShadowAnimation.current) {
      console.log("Reversing animation");
      cardShadowAnimation.current.reverse(); // Reverse animation on mouse leave
    }
  };

  return (
    <Link
      to={`/blogs/${item._id}`}
      onMouseEnter={onMouseEnterHandler}
      onMouseLeave={onMouseLeaveHandler}
      ref={cardRef}
      key={index}
      className="block transition-shadow duration-300 ease-in-out border border-gray-300 p-4"
    >
      <div className="flex flex-col group overflow-hidden">
        <img
          src={`http://localhost:9000/uploads/${item.image}`}
          width={60}
          height={60}
          className="justify-center group-hover:scale-105 ease-in-out duration-500"
          alt="Project Icon"
        />
        <h1 className="font-bold text-xl px-2 pt-4 text-black">{item.title}</h1>
        <p className="font-normal px-2 mb-2">
          {item.createdby} // {new Date(item.posted).toLocaleDateString()}
        </p>
        <p className="max-h-11 min-h-11 font-normal overflow-scroll mb-4 px-2 text-black text-ellipsis line-clamp-2">
          {item.excerpts}
        </p>
      </div>
    </Link>
  );
};

export default BlogCard;
